import { render } from "./LogoComponent.vue?vue&type=template&id=01f1cd68"
import script from "./LogoComponent.vue?vue&type=script&lang=js"
export * from "./LogoComponent.vue?vue&type=script&lang=js"

import "./LogoComponent.vue?vue&type=style&index=0&id=01f1cd68&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__